var _filter, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgWave4Shadow = function SvgWave4Shadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 200",
    filter: "url(#wave-4-shadow_svg__a)",
    enableBackground: "new 0 0 1600 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "wave-4-shadow_svg__a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.4
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1368.6 135.4c-157.4 10-247.9 49.6-340.9 49.4-93.1-.1-121-14.6-174.2-33.6-75.7-27.1-166.9-27.2-185.5-25.1-18.7 2.1-67.8 5.5-106-19.3-38.2-24.7-94.8-55.4-209.2-43.1C238.1 76.3 80 111.8-10 55.7v10c90 56.1 248.1 20.6 362.8 8 114.4-12.3 171 18.4 209.2 43.1 38.2 24.8 87.3 21.4 106 19.3 18.6-2.1 109.8-2 185.5 25.1 53.2 19 81.1 33.5 174.2 33.6 93 .2 183.5-39.4 340.9-49.4 160-10.2 241.4 23.1 241.4 23.1v-10s-81.4-33.3-241.4-23.1z"
  })));
};
export default SvgWave4Shadow;